import { createAction, props } from "@ngrx/store";

export const resetSpinner = createAction("[Spinner] Reset");
